var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section group"},[_c('b-card',{attrs:{"no-body":""}},[_c('b-tabs',{attrs:{"pills":"","card":"","vertical":""}},[_c('b-tab',{attrs:{"title-item-class":"mytab","title":_vm.$t('changePassword'),"active":true}},[_c('b-card-text',[_c('ChangePassword')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }